
export default {
  _returnIndexById(cartitems,id) {
    let result = {
      success: false,
      returned: Number
    }    
    for (var i = 0;i < cartitems.length;i++) {
      if (cartitems[i].id == id) {
        result.success = true
        result.returned = i
        break
      }
    }
    
    return result
  },
  
  _returnItemByKeyvalue(items,keyvalue) {
    let item = items.find((chat) => {
      return chat.keyvalue == keyvalue
    })
    
    return item
  }
}